import React from "react";
import { useTranslation } from "react-i18next";
import { ResourceTypes } from "@planzone/dto";
import { ActivateResourceIcon } from "@common/activateResourceIcon";
import { DeactivateResourceIcon } from "@common/deactivatedResourceIcon";
import { Props } from "./types";
import styles from "./styles.scss";
import { HumanResourceIcon } from "./humanResourceIcon";
import { MaterialResourceIcon } from "./materialResourceIcon";
import { VirtualResourceIcon } from "./virtualResourceIcon";

function ResourceTypesFilter(props: Props) {
  const { t } = useTranslation();
  const removeFilter = (filter: ResourceTypes) =>
    props.setFilters(props.filters.filter((type) => type !== filter));
  const addFilter = (filter: ResourceTypes) =>
    props.setFilters([...props.filters, filter]);
  const isSelected = (filter: ResourceTypes) =>
    props.filters.find((type) => type === filter);

  return (
    <ul className={styles.resourceTypesFilter}>
      <li
        className={styles.item}
        onClick={() =>
          isSelected(ResourceTypes.HUMAN)
            ? removeFilter(ResourceTypes.HUMAN)
            : addFilter(ResourceTypes.HUMAN)
        }
      >
        <HumanResourceIcon className={styles.icon} />
        <p
          className={
            isSelected(ResourceTypes.HUMAN) ? styles.selected : styles.name
          }
        >
          {t("planzoneMembersPage.resources.humanResource")}
        </p>
      </li>
      <li
        className={styles.item}
        onClick={() =>
          isSelected(ResourceTypes.MATERIAL)
            ? removeFilter(ResourceTypes.MATERIAL)
            : addFilter(ResourceTypes.MATERIAL)
        }
      >
        <MaterialResourceIcon className={styles.icon} />
        <p
          className={
            isSelected(ResourceTypes.MATERIAL) ? styles.selected : styles.name
          }
        >
          {t("planzoneMembersPage.resources.materialResource")}
        </p>
      </li>
      <li
        className={styles.item}
        onClick={() =>
          isSelected(ResourceTypes.VIRTUAL)
            ? removeFilter(ResourceTypes.VIRTUAL)
            : addFilter(ResourceTypes.VIRTUAL)
        }
      >
        <VirtualResourceIcon className={styles.icon} />
        <p
          className={
            isSelected(ResourceTypes.VIRTUAL) ? styles.selected : styles.name
          }
        >
          {t("planzoneMembersPage.resources.virtualResource")}
        </p>
      </li>
      <li
        className={styles.item}
        onClick={() => props.setActiveOnly(!props.activeOnly)}
      >
        <ActivateResourceIcon className={styles.icon} />
        <p className={props.activeOnly ? styles.selected : styles.name}>
          {t("planzoneMembersPage.resources.activeResource")}
        </p>
      </li>
      <li
        className={styles.item}
        onClick={() => props.setInactiveOnly(!props.inactiveOnly)}
      >
        <DeactivateResourceIcon className={styles.icon} />
        <p className={props.inactiveOnly ? styles.selected : styles.name}>
          {t("planzoneMembersPage.resources.inactiveResource")}
        </p>
      </li>
    </ul>
  );
}

export { ResourceTypesFilter };
